import styled from 'styled-components'
import { Link } from 'react-router-dom'
import { NumericFormat } from 'react-number-format'

export const Container = styled(Link)`
  background-color: #FFFFFF;
  width: 100%;
  height: 42px;
  padding: 0px 12px;
  margin-bottom: 10px;
  box-shadow: 0px 2px 10px -6px #252525;
  text-decoration: none;
  border-radius: 15px;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 10px;
  justify-content: center;
  align-items: center;

  &:hover {
    background-color: #F7F7F7;
  }
`

export const InfoText = styled.p`
  font-size: 14px;
  line-height: 16px;
  text-align: center;
  color: #000000;
  margin: 0px;
`

export const SubTitle = styled(InfoText)`
  font-weight: bold;
`

export const MoneyTextMask = styled(NumericFormat).attrs (props => {
  return {
    value: props.value.toFixed (2).replace ('.', ','),
    thousandSeparator: '.',
    decimalSeparator: ',',
    displayType: 'text',
    prefix: 'R$ '
  }
})`
  color: ${({value}) => parseFloat (value.replace (',', '.')) >= 0 ? '#44CF6C' : '#FF3939'};
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 0px;
  padding: 0px;
`
